import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';

export const unauthorizedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/403',
}).lazy(() => import('pages/shared/errors/Page403/Page403').then((d) => d.Route));
